import React from 'react';
import { Alert } from '@material-ui/core';
import { useTheme } from '@material-ui/core';

export default function RegisterError(props) {
    const theme = useTheme();
    const styles = {
        backgroundColor: theme.alerts.errorColor,
        textAlign: 'left',
        [".MuiAlert-icon"]: {
            color: theme.alerts.errorIconColor
        }
    }

    return <Alert severity="warning" sx={styles}>{props.message}</Alert>;
}
